export const DEFAULT_STATE = {
    list: null,
    isLoading: false,
};
